import axiosIns from '@/libs/axios'
import toErrorResult from '@/store/helpers/errorResult'

const UPLOAD_ERROR_MESSAGE = 'Dosya yüklenemedi. Bağlantınızı kontrol edip tekrar deneyin.'

/**
 * Dosya yükleme isteğini ilerleme bilgisiyle gönderir.
 * Store'da SET_UPLOADING, SET_UPLOAD_PROGRESS ve SET_DATA_SAVE mutation'ları bulunmalı.
 * Hata durumunda da { status: false, message } döner; uploading her durumda sıfırlanır.
 */
const uploadWithProgress = (commit, url, formData) => {
  commit('SET_UPLOADING', true)
  commit('SET_UPLOAD_PROGRESS', { loaded: 0, total: 0 })
  let lastPercent = -1
  return axiosIns
    .post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: event => {
        // Her olayda değil, yüzde değiştiğinde güncelle (gereksiz render'ı önler)
        const percent = event.lengthComputable ? Math.floor((event.loaded / event.total) * 100) : 0
        if (percent === lastPercent) {
          return
        }
        lastPercent = percent
        commit('SET_UPLOAD_PROGRESS', {
          loaded: event.loaded,
          total: event.lengthComputable ? event.total : 0,
        })
      },
    })
    .then(response => {
      commit('SET_DATA_SAVE', response.data)
      return response.data
    })
    .catch(error => {
      const result = { ...toErrorResult(error, UPLOAD_ERROR_MESSAGE), id: null }
      commit('SET_DATA_SAVE', result)
      return result
    })
    .finally(() => {
      commit('SET_UPLOADING', false)
      commit('SET_UPLOAD_PROGRESS', { loaded: 0, total: 0 })
    })
}

export default uploadWithProgress
